import { reqLogin, reqLoginEmail, reqLoginSms, reqUserInfo } from '@/api/modules/login'
import { reqPageRecord } from '@/api/modules/user'
import { reqKnowledgeCoursesDetail } from '@/api/modules/knowledgeBase'
import router from '@/router'
import { getToken, removeToken, removeSynthesisToken, setToken } from '@/utils/auth'

export const useUserStore = defineStore(
  // 唯一ID
  'user',
  () => {
    const token = ref(getToken())
    const userInfo: any = ref(null)

    const menus: any = ref([])

    function login({ data, type }: any) {
      const loginMethods: any = {
        password: reqLogin,
        email: reqLoginEmail,
        sms: reqLoginSms,
      }
      return new Promise((resolve, reject) => {
        loginMethods[type](data).then((res: any) => {
          setToken(res.data.access_token)
          token.value = res.data.access_token
          resolve(res)
        }).catch((error: any) => {
          reject(error)
        })
      })
    }
    // 获取用户信息
    function getInfo() {
      return new Promise((resolve, reject) => {
        reqUserInfo().then((res) => {
          userInfo.value = res.data
          resolve(res)
        }).catch((error) => {
          reject(error)
        })
      })
    }
    function logout(redirect = router.currentRoute.value.fullPath) {
      // 清除 token 信息
      removeToken()
      removeSynthesisToken()
      token.value = ''
      userInfo.value = null
      menus.value = []
      // 清除 synthesis store 中的 token
      const synthesisStore = useSynthesisStore()
      synthesisStore.token = ''
      // 跳转到登录页
      router.push({
        name: 'login',
        query: {
          ...(router.currentRoute.value.name !== 'login' && { redirect }),
        },
      })
    }
    async function pageLog(flag: any) {
      await reqPageRecord({ flag })
    }

    // 更新菜单名称（用于动态更新课程名称）
    function updateMenuName(path: string, newName: string) {
      const menu = menus.value.find((m: any) => m.path === path)
      if (menu) {
        menu.name = newName
      }
    }

    // 加载课程菜单名称
    async function loadCourseMenuName() {
      try {
        const res = await reqKnowledgeCoursesDetail({ id: 1 })
        if (res.data && res.data.name) {
          updateMenuName('/synthesis', res.data.name)
        }
      } catch (error) {
        console.error('加载课程菜单名称失败:', error)
      }
    }

    return {
      token,
      login,
      logout,
      getInfo,
      userInfo,
      menus,
      pageLog,
      updateMenuName,
      loadCourseMenuName,
    }
  },
)
